import { post, postExFile, postFile } from "@utils/httpUtil";

// 查询社区内容同步配置
export function getDoctorArticleSyncConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctorArticleSync/config/getDoctorArticleSyncConfig`, data, config);
}

// 编辑社区内容同步配置
export function updateDoctorArticleSyncConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctorArticleSync/config/updateDoctorArticleSyncConfig`, data, config);
}

// 分页查询内容同步列表
export function getDoctorArticleSyncPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctorArticleSync/pageList`, data, config);
}

// 导出同步列表数据
export function doctorArticleSyncExportData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/doctorArticleSync/exportData`, data, config);
}

// 内容同步设置-导入医生白名单
export function doctorArticleSyncConfigImportDoctorWhiteList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postFile(`/c/pc/doctorArticleSync/config/importDoctorWhiteList`, data, config);
}
